import { createFileRoute, Outlet } from "@tanstack/react-router";
import { DPA_PUBLISHED } from "shared/SharedConstants";
import AppHeader from "src/components/app/AppHeader/AppHeader";
import AppPageContainer from "src/components/app/AppPageContainer/AppPageContainer";
import SiteFooter from "src/components/app/SiteFooter/SiteFooter";
import { StatusPageLayout } from "src/components/app/StatusPage/StatusPageLayout";
import Link from "src/components/common/Link/Link";
import { useExtracted } from "#i18n";

// Policy pages: legal navigation in the header, footer below.
export const Route = createFileRoute("/_policies")({
  component: PolicyLayout,
});

function PolicyLayout() {
  const translateMessage = useExtracted();
  return (
    <>
      <AppHeader>
        <div className="flex items-center">
          <Link href="/privacy-policy">{translateMessage("Privacy")}</Link>
          <Link href="/terms">{translateMessage("Terms of Service")}</Link>
          <Link href="/copyright">{translateMessage("Copyright / DMCA")}</Link>
          <Link href="/cookies">{translateMessage("Cookies")}</Link>
          <Link href="/trust">{translateMessage("Trust")}</Link>
          {DPA_PUBLISHED ? <Link href="/dpa">{translateMessage("DPA")}</Link> : null}
          <Link href="/data-request">{translateMessage("Your data")}</Link>
        </div>
      </AppHeader>
      <main id="main-content" tabIndex={-1}>
        <AppPageContainer className="flex flex-col overflow-x-hidden pt-20 sm:pt-28">
          <StatusPageLayout>
            <Outlet />
          </StatusPageLayout>
        </AppPageContainer>
      </main>
      <SiteFooter className="flex-1" />
    </>
  );
}
